import { LazyStore } from "../utils/Store";
import type { ICartStore } from "./common-cart/CommonCartStore";
import type { CommonCart } from "../model/CommonCartTypes";
import { CustomerCartStore } from "./customer-cart/CustomerCartStore";
import { SessionStore } from "../uidispatcherapi/SessionStore";
type ReplacementButtonInternalState = {
	cartItemIds: string[];
};
export type ReplacementButtonState = ReplacementButtonInternalState & {
	storeId: string | null | undefined;
	isLoggedIn: boolean;
	isEmployee: boolean;
};
export class ReplacementButtonStore extends LazyStore {
	state!: ReplacementButtonInternalState;

	constructor(cartStore: ICartStore) {
		super();
		this.resetState();

		this.onArm = () => {
			this.listenTo(cartStore, () => this.handleCartUpdate(cartStore.getCart()));
			this.handleCartUpdate(cartStore.getCart());
		};

		this.onDisarm = this.resetState;
	}

	resetState = () => {
		this.state = {
			cartItemIds: [],
		};
	};
	getState = (): ReplacementButtonState => {
		return {
			...this.state,
			storeId: SessionStore.getCustomerStore(),
			isLoggedIn: SessionStore.loggedIn(),
			isEmployee: SessionStore.isEmployee(),
		};
	};
	handleCartUpdate = (cart: CommonCart | null) => {
		const cartItemIds: string[] = cart ? Object.keys(cart.items) : [];

		if (
			cartItemIds.length !== this.state.cartItemIds.length ||
			cartItemIds.some((entry) => !this.state.cartItemIds.includes(entry))
		) {
			this.state = {
				cartItemIds,
			};
			this.trigger();
		}
	};
}
export default new ReplacementButtonStore(CustomerCartStore);
